<div class="content" [ngClass]="{'phase-content': phaseId}">
  @if (content?.collapsible) {
    <div>
      <mat-expansion-panel [togglePosition]="'before'">
        <mat-expansion-panel-header>
          <mat-panel-title>
            {{ content?.title }}
          </mat-panel-title>
        </mat-expansion-panel-header>
        <app-show-content [content]="content" [phaseId]="phaseId"></app-show-content>
      </mat-expansion-panel>
    </div>
  }
  @if (!content?.collapsible) {
    <app-show-content [content]="content" [phaseId]="phaseId"></app-show-content>
  }
</div>
